export default __webpack_public_path__ + "static/media/INXC.93665133.svg";